import React, { FC, ReactNode } from 'react';

import { MENU_SHIMMER_ID } from 'routes/Menu/MenuCategories/Shimmer/const';

import styles from './styles.module.scss';
import { ShimmerCard } from 'components/ShimmerCard/ShimmerCard';
import { MenuSection } from 'components/MenuSection/MenuSection';

const TOTAL_CATEGORIES = 3;

type ShimmerProps = {
  // TODO this prop can be removed once we start supporting item images in our menu
  // until then, we should explicitly set it to false
  showItemImage?: boolean;
};

const Shimmer: FC<ShimmerProps> = ({ showItemImage }) => {
  const items: ReactNode[] = [];
  for (let i = 0; i < TOTAL_CATEGORIES; i++) {
    // eslint-disable-next-line functional/immutable-data
      items.push(
        <MenuSection key={i} shimmer>
          <ShimmerCard showItemImage={showItemImage} />
          <ShimmerCard showItemImage={showItemImage} />
          <ShimmerCard showItemImage={showItemImage} />
          <ShimmerCard showItemImage={showItemImage} />
        </MenuSection>
      );
  }

  return (
    <div className={styles.container} data-testid={MENU_SHIMMER_ID}>
      {items}
    </div>
  );
};

export { Shimmer };
